exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-g-js": () => import("./../../../src/pages/g.js" /* webpackChunkName: "component---src-pages-g-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-u-js": () => import("./../../../src/pages/u.js" /* webpackChunkName: "component---src-pages-u-js" */)
}

